import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'

import {Card, CardHeader, CardContent,CardActions } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '../Button';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

/** 
 * PaymentMethodCard component.
 * Displays textfields related to payments card infos 
*/

const styles = theme => ({
    header: {
        background: blue[500],  
    },
    title: {
        color: '#FFF'
    },
    first: {
        marginBottom: 24,
    },
    second: {
        marginTop:24, 
        marginBottom:24,
    },
    button: {
        marginRight:14, 
        marginLeft:14, 
        marginBottom:24,
    }
  });

class PaymentMethodCard extends Component {

  render() {

    const {classes} = this.props;

    return (
        <div >
            <Card >
                <CardHeader
                    className={classes.header}
                    title={
                        <span >
                            <Typography 
                                className={classes.title} 
                                variant="h6">
                                    Add payment method
                            </Typography>
                        </span>
                    }
                />
                <CardContent>
                    <Grid container direction='row' spacing={8}>
                        <Grid item xs={8}>
                            <TextField variant="outlined" label="Card number" required
                            InputLabelProps={{disableAnimation:true, shrink:true}}/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="outlined" label="Expiration date" required
                            InputLabelProps={{disableAnimation:true, shrink:true}}/>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' spacing={8} className={classes.second}>
                        <Grid item xs={8}>
                            <TextField variant="outlined" label="Name" required
                            InputLabelProps={{disableAnimation:true, shrink:true}}/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="outlined" label="CVV" required
                            InputLabelProps={{disableAnimation:true, shrink:true}}/>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <Button 
                        fullWidth 
                        size="medium" 
                        color="primary" 
                        variant="contained" 
                        className={classes.button}
                        >
                        <FormattedMessage id='billingInfo.button.confirm' />
                    </Button>
                </CardActions>
        </Card>
      </div>
    )
  }

}

export default withStyles(styles)(PaymentMethodCard);



// WEBPACK FOOTER //
// ./src/components/billingInfo/PaymentMethodCard.js